<script>
    import { capitalizeFirstLetter } from "@/utils";

    export default {
        name: "ThePersonalLinkCard",
        props: {
            title: String,
            type: String,
            routeHash: String,
        },
        computed: {
            routeName() {
                return "ThePersonal" + capitalizeFirstLetter(this.type);
            },
        },
    };
</script>

<template>
    <router-link
        class="the-personal-link-card"
        :to="{ name: routeName, hash: this.routeHash }"
    >
        <div class="the-personal-link-card__title">{{ title }}</div>
        <div class="the-personal-link-card__info">
            <slot></slot>
        </div>
        <div class="the-personal-link-card__image">
            <img :src="`/static/${$root.$_name}/profile/main-${type}.png`" alt="" />
        </div>
    </router-link>
</template>

<style lang="scss">
    .the-personal-link-card {
        position: relative;
        display: flex;
        flex-direction: column;
        min-height: 100px;
        padding: 10px 15px 15px;
        color: inherit;
        box-shadow: $personal-common-shadow-min;
        border: $personal-border-width solid $personal-common-border-color;
        border-radius: $personal-box-radius;
        transition: box-shadow 0.2s ease-in, border-color 0.2s ease-in;
        @include bp($bp-desktop-sm) {
            min-height: 140px;
            padding: 20px 20px 25px;
            &:hover {
                border-color: $personal-card-border-color;
                box-shadow: none;
            }
            &:active {
                border-color: $personal-card-border-color--active;
                box-shadow: none;
            }
        }
    }

    .the-personal-link-card__title {
        margin-bottom: auto;
        color: $personal-card-title-color;
        font-family: $personal-card-title-font;
        font-size: 14px;
        font-weight: $personal-card-title-weight;
        letter-spacing: $personal-card-title-spacing;
        line-height: 16px;
        text-transform: $personal-card-title-case;
        @include bp($bp-desktop-sm) {
            font-size: 18px;
            line-height: 23px;
        }
    }

    .the-personal-link-card__info {
        max-width: 200px;
        color: $personal-card-text-color;
        font-weight: $personal-card-text-weight;
        font-size: 12px;
        line-height: 16px;
        b {
            color: $personal-card-title-color;
        }
        @include bp($bp-desktop-sm) {
            display: flex;
            align-items: center;
            max-width: 270px;
            font-size: 14px;
        }
    }

    .the-personal-link-card__image {
        position: absolute;
        z-index: -1;
        right: -$personal-border-width;
        bottom: -$personal-border-width;
        width: 107px;
        border-radius: $personal-box-radius;
        overflow: hidden;
        img {
            width: 100%;
            height: 100%;
        }
        @include bp($bp-desktop-sm) {
            width: 155px;
        }
    }
</style>
